import type Department from '../department/department';
import type RoomOccupation from './room-occupation';

interface RoomWorkplace {
  id?: string;
  qrCodeId?: string;
  /**
   * The date this desk stops being bookable, `yyyy-MM-dd`, or absent when it is not retiring.
   *
   * A date rather than a resolved flag, because the answer depends on the day being booked: the
   * same desk is available for next Tuesday and gone for the Tuesday after. The server has sent
   * this since the retirement work landed (DESK_RETIREMENT_PLAN.md section 4.3, site 12).
   */
  retiresOn?: string;
}

class RoomObsolete {
  id?: string;

  name = '';

  capacity = 0;

  isReservableThroughFloorPlan = false;

  departments: Department[] = [];

  roomOccupations?: RoomOccupation[];

  workplaces: RoomWorkplace[] = [];
}

export type { RoomWorkplace };
export default RoomObsolete;
